export default __webpack_public_path__ + "static/media/desplegarGris.dfd45679.svg";